// Pure gate for ModalComponent#contentContainerClicked.
//
// Dismiss only when the event lands on the content container itself (the empty
// area around the modal box). Clicks on ANY child — the content box, or chrome
// portaled into the modal layer as a sibling of `.t-modal-content` (builder
// level/adder pills live in `.js-node-visual-controls-overlay` inside
// `.t-modal-content-outer`) — must not close the modal.
//
// Extracted so unit tests exercise the same function the controller calls.
export function shouldDismissOnContentContainerClick(
  event,
  { dismissable, closeOnOverlayClick, ignoreOverlayDismissUntil = 0, now = Date.now() }
) {
  if (ignoreOverlayDismissUntil && now < ignoreOverlayDismissUntil) {
    return false
  }

  return (
    event.target === event.currentTarget &&
    !!event.target?.isConnected &&
    !!dismissable &&
    !!closeOnOverlayClick
  )
}
